/*
 * Copyright (c) 2023. 듣고 배우는 한국어 프로젝트.
 * by jhpark
 */
import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";

import {CITY2, CITY2_DEFAULT, isCity2, REGION, REGION2, REGION2_DEFAULT} from '../../shared/defines/gukeo.const';
import {
  CITY2_INFO,
  CITY2_INFO_LIST, CITY2_INFO_MAP, REGION_INFO2,
  REGION_INFO2_LIST,
  REGION_INFO2_MAP,
  REGION_LIST
} from 'src/app/shared/defines/desktop.const';
import {fadeInOut, LIST_TYPE, SearchParam} from "../../shared/defines/client.const";
import {GlobalEventService} from "../../shared/services/global-event/global-event.service";

/** 지도 위에 비활성 상태로만 노출되는 지역 라벨 뷰 모델 (선택 불가) */
type INACTIVE_REGION_LABEL = {
  name: string;
  ariaLabel: string;
};


/**
 * 사투리 지역 선택 지도 컴포넌트
 */
@Component({
  selector: 'app-dialect-region-map',
  templateUrl: './dialect-region-map.component.html',
  styleUrls: ['./dialect-region-map.component.scss'],
  animations: [fadeInOut],
})
export class DialectRegionMapComponent implements OnInit {
  @HostBinding('class') class = 'map-bg-box';
  @HostBinding('style.display') styleBlock = 'block';
  @Input() city: CITY2 = CITY2_DEFAULT;
  @Input() set region( value: REGION) {
    if (value !== this.selectedRegion) {
      this.selectedRegion = value;
    }
  }
  @Output() changeRegion = new EventEmitter<CITY2>();
  @Output() zoomRegion = new EventEmitter<REGION>();

  protected readonly REGION = REGION;
  protected readonly CITY2_DEFAULT = CITY2_DEFAULT;
  protected readonly REGION2_DEFAULT = REGION2_DEFAULT;
  protected readonly inactiveRegionLabel: INACTIVE_REGION_LABEL = {
    name: '경기도',
    ariaLabel: '경기도 (선택 불가)',
  };

  protected selectedRegion: REGION = REGION.ALL;

  // 줌이 가능한 지역만 목록을 만든다.
  protected zoomResionList = REGION_LIST.filter(info => [
    REGION.CHUNGCHEONG, REGION.GANGWON, REGION.GYEONGSANG, REGION.JEONLA, REGION.JEJU].includes(info.region));

  protected getCity2InfoList(): CITY2_INFO[] {
    return CITY2_INFO_LIST.filter(info => info.region === this.selectedRegion);
  }

  protected getRegion2InfoList(): REGION_INFO2[] {
    return REGION_INFO2_LIST.filter(info => info.region === this.selectedRegion);
  }

  constructor(
    private router: Router,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngOnInit(): void {
    // 도시가 선택되어있으면, 지역을 자동으로 선택해주는 기능을 제거. (아래)
    // if (this.selectedRegion !== REGION.ALL && isCity2(this.city)) {
    //    this.selectedRegion = CITY2_INFO_MAP.get(this.city)?.region ?? REGION.ALL;
    //  }
  }

  protected onClickCity($event: MouseEvent, city2: CITY2) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.city = city2;
    this.changeRegion.emit(city2);
  }

  protected onGotoDialistList($event: MouseEvent, region2: REGION2): void {
    console.log('DialectRegionMapComponent.onGotoDialistList()', $event);
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    const regionText = REGION_INFO2_MAP.get(region2)?.region2 ?? CITY2_DEFAULT;
    if (regionText) {
      const queryParams: SearchParam = {
        ...(region2 !== '전국' ? {region2: regionText} : {}),
      };

      this.router.navigate(['/dialect-list', LIST_TYPE.SERVER], {queryParams}).then();
    }
    else {
      console.error('DialectMenuComponent::onGotoDialistList() invalid region =', region2);
    }
  }

  onZoomRegion($event: MouseEvent, region: REGION) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.selectedRegion = region;

    this.zoomRegion.emit(region);
  }
}
